module.exports = __webpack_public_path__ + "static/media/logo_voala.380072e4.svg";